import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { GivingAccountReviewResponse, SetGivingAccountReviewStatusParams } from './types';

export async function setGivingAccountReviewStatus(
  givingAccountId: string,
  params: SetGivingAccountReviewStatusParams
) {
  const url = `/web/studio/giving-accounts/${givingAccountId}/review`;

  /* eslint-disable camelcase */
  const body: { manual_review_status: string; reviewer_note?: string | null } = {
    manual_review_status: params.manualReviewStatus,
  };
  if (params.reviewerNote !== undefined) body.reviewer_note = params.reviewerNote;
  /* eslint-enable camelcase */

  const response = await api.executePutRequest<ObjectResponse<GivingAccountReviewResponse>>(url, body);

  return response.data;
}
